import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';

export const messages = defineMessages({
  emptyText: {
    defaultMessage:
      'There aren’t any member rewards today. But if they’re available we’ll automatically add any to your cart.',
  },
});

export const EmptyCoupons = () => {
  const intl = useIntl();
  return <Text type="body2">{intl.formatMessage(messages.emptyText)}</Text>;
};
